export default __webpack_public_path__ + "static/media/tuto1.03892bef.png";